// extracted by mini-css-extract-plugin
export var center = "_4c-2";
export var clickableRow = "_4c-5";
export var expandedRow = "_4c-7";
export var hoverable = "_4c-4";
export var left = "_4c-1";
export var right = "_4c-3";
export var row = "_4c-0";
export var selectedRow = "_4c-6";
export var summaryRow = "_4c-8";